export default class Theme {
  static colorBluePrimary = "#131CE9";
  static colorFontBlack = "#454545";
  static colorFontWhite = "#FFFFFF";
  static colorFontLabel = "#8F8F8F";
  static colorBackgroundBox = "#FFFFFF";
  static colorBackgroundPage = "#F9F9F9";
  static colorNotSelected = "#8F8F8F";
  static colorBorderTextField = "#C7C7C7";
  static colorIconButton = "#F9F9F9";
  static colorFontHover = "#000000";
  static colorBackgroundBoxHover = "#dddddd";
  static colorBackgroundBoxLable = "#F5F7F8";
  static colorBackgroundBoxLableActive = "#22C55E";
  static colorRed = "#EF4444";
  static fontNavSize = "12px";
  static fontSize = "14px";
  static fontInfoSize = "16px";
  static fontTitleSize = "22px";
  static fontWeight = "500";
  static fontNavWeight = "400";
  static fontInfoWeight = "700";
  static borderRadius = "16px";
  static inputWidth = "301px";
  static inputHeight = "52px";
}
